import { Badge } from '@mantine/core';
import type { RarityType } from '@/types';
import { translate } from '@/lib';

interface RarityBadgeProps {
  rarity: RarityType;
  rare?: number; // Tier ID (1-9) for gradient class
  color?: string; // Optional color from API (fallback)
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export function RarityBadge({ rarity, rare, color, size = 'sm' }: RarityBadgeProps) {
  const translationKey = `ff.rarity.${rarity?.toLowerCase?.()}` as const;
  
  // Use tier class for gradient background
  const tierBgClass = rare ? `tier-bg-${rare}` : '';
  
  return (
    <Badge
      size={size}
      variant="filled"
      className={tierBgClass}
      styles={{
        root: {
          textTransform: 'uppercase',
          fontWeight: 700,
          // Fallback color if no tier class
          ...(!rare && color ? { backgroundColor: color } : {}),
        },
      }}
    >
      {rarity || translate(translationKey, rarity)}
    </Badge>
  );
}

